import { useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Copy, Check, Loader2, Share2 } from "lucide-react";

export default function ShareProfile() {
  const [p, setP] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/candidate/profile").then((r) => setP(r.data)).catch(() => {}); }, []);

  if (!p) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-blue-700" /></div>;

  const link = `${window.location.origin}/p/${p.public_slug}`;
  const copy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    toast.success("Link skopírovaný");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="px-6 pt-12">
      <h1 className="font-head text-2xl font-bold tracking-tight">Zdieľať profil</h1>
      <p className="mt-2 text-slate-600">Neposielaš CV. Pošleš iba link alebo QR kód.</p>

      <div className="mt-8 rounded-3xl bg-white border border-slate-200 shadow-sm p-8 flex flex-col items-center fade-up">
        <div className="p-4 rounded-2xl bg-white border border-slate-100 shadow-sm">
          <QRCodeCanvas value={link} size={200} fgColor="#0F172A" level="M" data-testid="profile-qr" />
        </div>
        <p className="mt-6 text-sm text-slate-500">Tvoj Career Passport</p>
        <p className="font-head font-semibold text-slate-900 break-all text-center">{link.replace(/^https?:\/\//, "")}</p>
      </div>

      <button data-testid="copy-link-btn" onClick={copy}
        className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-blue-700 text-white hover:bg-blue-800 rounded-full px-6 py-4 font-semibold transition-colors active:scale-95">
        {copied ? <Check size={18} /> : <Copy size={18} />} {copied ? "Skopírované" : "Kopírovať link"}
      </button>

      <button data-testid="share-native-btn"
        onClick={() => navigator.share ? navigator.share({ title: "Môj Career Passport", url: link }) : copy()}
        className="mt-3 w-full inline-flex items-center justify-center gap-2 bg-white text-slate-700 border border-slate-300 hover:bg-slate-50 rounded-full px-6 py-4 font-semibold transition-colors active:scale-95">
        <Share2 size={18} /> Zdieľať
      </button>
    </div>
  );
}
